import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { Link } from 'react-router-dom';
import {
	setInitialLoginState,
	otplogin,
	setUserType,
} from '../../../redux/userAuthentication/userAuth.actions';
import { setErrorPanel } from '../../../redux/utilities/utils.actions';
import FootNote from '../sharedComponents/footNote';
import '../userAuthenticationStyles.css';
import { trimText, isValidLoginId } from '../../../utils/commonFunctions';
import Config from '../../../config/Config';
import NameField from '../sharedComponents/nameField';
import ResendPin from '../sharedComponents/resendPin';
import Loader from '../../../utils/Loader';

const ParentSignUp = ({
	error: { panelClass, panelMsg },
	loginId,
	setErrorPanel,
	createUser,
	setUserType,
	userType,
}) => {
	useEffect(() => {
		setErrorPanel({
			errorPanel: {
				panelClass: '',
				panelMsg: '',
			},
		});
		Loader.hide();
	}, [setErrorPanel]);

	const validateName = () => {
		loginId = trimText(loginId);
		let panelMsg = isValidLoginId(loginId);
		localStorage.setItem('login_id', loginId);

		if (panelMsg.length > 0) {
			setErrorPanel({
				panelClass: 'alert alert-danger',
				panelMsg,
			});
			return false;
		} else {
			createUser(loginId);
		}

		return true;
	};

	return (
		<div id="wrapper">
			<div className="col-lg-12 col-md-12 col-sm-12 login-pg-container">
				<div className="col-lg-12 col-md-12 col-sm-12 login-wrapper-container">
					<form action="" className="form-horizontal step-login-form" method="">
						<div className="col-lg-offset-4 col-md-offset-4 col-lg-4 col-md-4 col-sm-12 login-box">
							<div className="login-theader">
								<img src={Config.ASSETSPATH + 'img/STEP_logo.png'} alt="STEPlogo" />
							</div>
							<div className="message_box">
								<div className={panelClass}>{panelMsg}</div>
							</div>
							<h4>Welcome to STEP's Online Olympiad for Classes 3 to 10!</h4>
							<p>
								{window.location.pathname === '/parent/login'
									? 'Please enter your registered phone number/email ID to receive an OTP'
									: `Please enter your phone number/email ID to start the registration
								process for your child. You will receive an OTP on the entered phone
								number/email ID.`}
							</p>
							{/* <div className="clogin-name-field sign-in-text">{headerText}</div> */}
							<div className="login-formbox">
								<div className="form-group">
									<NameField />
									<ResendPin resendText="Forgot Password? Click here!" />
								</div>
							</div>

							<button
								aria-label="login"
								id="loginBtn"
								type="button"
								className="btn-step-signin btn-primary"
								onClick={validateName}
							>
								Continue
							</button>
							{window.location.pathname === '/parent/login' && (
								<div className="login-orlabel text-center">
									<Link to="/parent/signup">Click here if you wish to register</Link>
								</div>
							)}
							<hr />
							<FootNote userActivity="Continue" />
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { loginId, success, userType } = state.rootReducer.loginDetails;
	return {
		loginId,
		error: state.rootReducer.utils.errorPanel,
		success,
		userType,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setErrorPanel: (errorText) => dispatch(setErrorPanel(errorText)),
		updateState: (value) => dispatch(setInitialLoginState(value)),
		createUser: (val) => dispatch(otplogin(val)),
		setUserType: (type) => dispatch(setUserType(type)),
	};
};

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(ParentSignUp),
);
